<template>
    <Modal
    :value="open"
    :onClose="close"
    :close="false"
    title="Importar Pedido"
    >
    <b-row class="form-group">
      <b-col class="busca">
        <Label bold>Pedido</label>
        <vSelect label="name"
          v-model="pedido"
          @search="search"
          class="busca-pedidos"
          ref="buscaPedidos"
          :options="listaPedidos"
          :filterable="filterable"
          @input="changePedidoSelected">
          <template slot="no-options">
            Selecione um pedido
          </template>
          <template slot="option" slot-scope="option">
            <strong>{{ formatDate(option.created) }} - {{ option.name}}</strong><br>
            {{ 'N° ' +  option.sequence + ' R$: ' + valorSubTotalReal(option.price, maximumFractionDigits) }}
          </template>
          <template slot="selected-option" slot-scope="option">
            <slot name="selected" :data="option"></slot>
          </template>
        </vSelect>
      </b-col>
    </b-row>

    <div class="confirm-buttons">
      <Button type="error" @click="close()">Fechar</Button>
      <Button type="success" @click="save()">Importar</Button>
    </div>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { Button } from '@/components/Form';
import vSelect from 'vue-select';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';

export default {
  name: 'ModalImportarPedido',
  mixins: [
    FormatMixin,
  ],
  components: {
    Modal,
    Button,
    vSelect,
  },
  data() {
    return {
      listaPedidos: [],
      pedido: null,
      filterable: false,
      maximumFractionDigits: 2,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
    changePedido: {
      type: Function,
      required: true,
    },
    pedidos: {
      required: true,
    },
    search: {
      type: Function,
      required: true,
    },
  },
  watch: {
    pedidos(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listaPedidos = newValue;
      }
    },
  },
  methods: {
    changePedidoSelected(pedidoSelected) {
      this.pedido = pedidoSelected;
    },
    async save() {
      if (await this.changePedido(this.pedido)) {
        const storedSales = window.localStorage.getItem('sale_id') || '';
        localStorage.setItem('sale_id', storedSales.concat(`,${this.pedido.id}`));
        this.pedido = null;
      }
    },
  },
};
</script>
